module.exports = __webpack_public_path__ + "img/25.00c24b9b.svg";